import React from 'react';
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCardImage,
  MDBBtn
} from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ServiceCardProps {
  title?: string;
  description?: string;
  image?: string;
}

export default function ServiceCard({ title = 'Card title', description = 'Some quick example text to build on the card title and make up the bulk of the card\'s content.', image = 'https://mdbootstrap.com/img/new/standard/nature/184.webp' }: ServiceCardProps) {
  const { t } = useTranslation();

  return (
    <MDBCard className='h-100'>
      <div style={{ height: '200px', overflow: 'hidden' }}>
        <MDBCardImage 
          src={image} 
          position='top' 
          alt={title}
          style={{
            width: '100%',
            height: '200px',
            objectFit: 'cover'
          }}
        />
      </div>
      <MDBCardBody className='d-flex flex-column'>
        <MDBCardTitle>{title}</MDBCardTitle>
        <MDBCardText>
          {description}
        </MDBCardText>
        <Link to="/contact">
          <MDBBtn href='#' className='mt-auto'>{t('services.book')}</MDBBtn>
        </Link>
      </MDBCardBody>
    </MDBCard>
  );
}